"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GET_PRODUCTS_TERMINAL_NODE = void 0;
const gql_1 = require("../../../../__generated__/gql");
exports.GET_PRODUCTS_TERMINAL_NODE = (0, gql_1.gql)(`
 query ProductsTerminalNode($first: Int, $sort: [ProductPresentationsOrderBy!]!, $filter: ProductFilter, $productTrees: [ID!]) {
  products(filter: $filter) {
   edges {
     node {
       presentations(productTrees: $productTrees, first: $first, sort: $sort) {
         edges {
           node {
             productTreeNode {
               id
               title
             }
           }
         }
       }
     }
   }
 }
 }
`);
